import { AxiosRequestConfig } from 'axios';

import { store } from 'src/main';
import { getSessionToken } from 'app/config';

import { prepareTimestamp } from '../helpers';

const detectOS = (): string => {
	if (typeof window === 'undefined' || !window.navigator) {
		return 'Unknown OS';
	}

	const { userAgent, platform } = window.navigator;
	const lowerPlatform = platform?.toLowerCase() || '';
	const lowerUserAgent = userAgent?.toLowerCase() || '';

	if (lowerPlatform.includes('win')) return 'Windows';
	if (lowerPlatform.includes('mac')) return 'macOS';
	if (lowerPlatform.includes('linux')) return 'Linux';
	if (lowerUserAgent.includes('android')) return 'Android';
	if (/iphone|ipad|ipod/.test(lowerUserAgent)) return 'iOS';

	return 'Unknown OS';
};

function updateHeaders(config: AxiosRequestConfig) {
	const token = getSessionToken(store.getState().user.sessionToken);
	if (token) config.headers['Authorization'] = `Token ${token}`;

	config.headers['Accept-Language'] = 'ru';

	if (!config.headers['Accept']) config.headers['Accept'] = 'application/vnd.api+json';
	if (!config.headers['Content-Type']) config.headers['Content-Type'] = 'application/json';
}

function updateCustomHeaders(config: AxiosRequestConfig) {
	let withCustomHeader = true;

	// don`t use custom header for external `suggestions` service
	if (config.url?.includes('/suggestions/')) withCustomHeader = false;

	if (withCustomHeader) {
		const os = detectOS();
		config.headers['Warning'] = `299 - "version for ${os} 2.61"`;
	}
}

function updateCookie() {
	const dateNow = Date.now();
	const value = prepareTimestamp(dateNow);
	const name = '_vtk';
	const options = 'Path=/; Domain=vezzer.no; SameSite=None; Secure';

	document.cookie = `${name}=${encodeURIComponent(value)}; ${options}`;
}

export function preprocessRequest(config: AxiosRequestConfig) {
	updateHeaders(config);
	updateCustomHeaders(config);
	updateCookie();

	return config;
}
